import { Injectable, TemplateRef } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';
import { Subject, of } from 'rxjs';

export interface INotification {
  message: string;
  duration: number;
  type: 'warning' | 'info' | 'success' | 'none' | 'error';
}
@Injectable({
  providedIn: 'root',
})
export class ClearNotificationService {
  public notificationTemplate: TemplateRef<any>;
  private notificationHorzontal: 'left' | 'center' | 'right' = 'center';
  private notificationVertical: 'top' | 'bottom' = 'bottom';
  constructor(private notificationService: NotificationService) {}

  public showNotification(Notification: INotification) {
    this.notificationService.show({
      // appendTo: this.invesComponent.investigationSplitter,
      content: Notification.message,
      cssClass: 'Bigger-Notification',
      animation: { type: 'slide', duration: 400 },
      position: {
        horizontal: this.notificationHorzontal,
        vertical: this.notificationVertical,
      },
      type: { style: Notification.type ?? 'success' },
      hideAfter: Notification.duration ?? 3000,
    });
  }
}
